var en = require('./translations/en.json')
var he = require('./translations/he.json')

export default Object.assign(en, he)
